/**
 * phase-classification-stage-0-fixes item 1 — the CLIENT half of the one
 * "classifiable" definition (server: src/lib/documents/classifiable.ts →
 * applyClassifiableFilter). A document needs classification when it has no
 * classification value, HAS an uploaded file, is not confirmed — and is NOT
 * a template-generated document (Sharon's ruling, 2026-08-01: a generated
 * document's placement comes from the template that produced it and is
 * authoritative; it never enters the classification pipeline, the badge
 * count, Classify All, or any per-document classify affordance).
 */
export interface ClassifiableLike {
  readonly Classification?: string | null;
  readonly ClassificationApprovedAt?: string | null;
  readonly ClassificationApprovedValue?: string | null;
  readonly Sha256Hash?: string | null;
  readonly ConfirmedAt?: string | null;
  readonly ClassificationStatus?: string | null;
  readonly GeneratedFromTemplateId?: string | null;
}

export function isGeneratedDocument(d: ClassifiableLike): boolean {
  return d.ClassificationStatus === 'generated' || Boolean(d.GeneratedFromTemplateId);
}

export function isClassifiableDocument(d: ClassifiableLike): boolean {
  if (isGeneratedDocument(d)) return false;
  const accepted = Boolean(d.ClassificationApprovedAt && d.ClassificationApprovedValue?.trim());
  return !accepted && !d.Classification?.trim() && Boolean(d.Sha256Hash) && !d.ConfirmedAt;
}
